import { mount } from '@porotutu/react'
import { buildRouter } from './router/router'
import { profileQuery } from './session/profile'

mount({ profileQuery, buildRouter })
